
// Sentry error reporting tool only for prouction
// (we don't need error mails while developing)
if (window.KwIntern.env !== 'local') {
  require('./sentry');
}

// Load all project dependencies
require('./bootstrap');

// Add scripts that need to run on page load
require('./init');

// Now we just add Vue to the whole page to kickstart the site
require('./vue');



// WEBPACK FOOTER //
// ./resources/assets/js/app.js